import React from 'react';
import { KPICard } from '../../types/executiveChat';
import './KPICards.css';

interface KPICardsProps {
  data: KPICard[];
}

const KPICards: React.FC<KPICardsProps> = ({ data }) => {
  const getTrendIcon = (trend?: 'up' | 'down' | 'neutral') => {
    switch (trend) {
      case 'up': return '⬆️';
      case 'down': return '⬇️';
      case 'neutral': return '➡️';
      default: return '';
    }
  };

  return (
    <div className="exec-kpi-grid">
      {data.map((card, index) => (
        <div key={index} className="exec-kpi-card">
          <div className="exec-kpi-label">{card.label}</div>
          <div className="exec-kpi-value">{card.value}</div>
          {card.desc && <div className="exec-kpi-desc">{card.desc}</div>}
          {card.change && (
            <div className="exec-kpi-change">
              {getTrendIcon(card.trend)} {card.change}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default KPICards;














